import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route } from 'react-router-dom';

import './App.css';

// Layouts
import MainLayout from './layouts/MainLayout';
import DashboardLayout from './layouts/DashboardLayout';

// Public components
import Home from "./components/home/Home";
import About from "./components/About/About";
import Register from "./components/Register/Register";
import Resources from "./components/Resources/resources";
import Portal from './components/Portal/Portal';
import Contact from './components/Contact/Contact';
import Gallery from './components/Gallery/gallery';
import Compliments from './components/compliments/compliments';
import Inquiries from './components/inquiries/inquiries';
import Complaints from "./components/Complaints/complaints";
import Report from './components/Report/Report';
import Registration from './components/Services/Registration';
import SurveyCourse from './components/Services/SurveyCourse';
import SurveyorReg from './components/Services/SurveyorReg';
import AnnualLicence from './components/Services/AnnualLicence';
import ApprovedReg from './components/Services/ApprovedReg';
import IDCards from './components/Services/IDCards';
import EventsReg from './components/Services/EventsReg';
import LandLaw from './components/Services/LandLaw';
import TitleSurv from './components/TitleSurv/TitleSurv';
import EngageSurv from './components/EngageSurv/EngageSurv';
import TrialSurvey from './components/TrialSurvey/TrialSurvey';
import NotFound from './components/NotFound';
import PublicProfile from './components/Register/Profiles/PublicProfile';
import PrivacyPolicy from './components/Footer/PrivacyPolicy';
import Verify from './components/Verify/Verify';
import ResetPassword from './components/Portal/ResetPassword';
import ResetMail from './components/Portal/ResetMail';
import Profile from './components/Register/Profiles/PublicProfile';

// Dashboard components
import Dashboard from './components/Dashboard/Dashboard';
import MainDashboard from './components/Dashboard/MainDashboard';
import FinalDashboardL from './components/FinalDashboard/FinalDashboardL';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<MainLayout />}>
        <Route path="/" exact element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/register" element={<Register />} />
        <Route path="/compliments" element={<Compliments />} />
        <Route path="/inquiries" element={<Inquiries />} />
        <Route path="/complaints" element={<Complaints />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/report" element={<Report />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/surveyorreg" element={<SurveyorReg />} />
        <Route path="/annuallicence" element={<AnnualLicence />} />
        <Route path="/approvedReg" element={<ApprovedReg />} />
        <Route path="/idcards" element={<IDCards />} />
        <Route path="/eventsReg" element={<EventsReg />} />
        <Route path="/landLaw" element={<LandLaw />} />
        <Route path="/surveyCourse" element={<SurveyCourse />} />
        <Route path="/trialSurvey" element={<TrialSurvey />} />
        <Route path="/titleSurv" element={<TitleSurv />} />
        <Route path="/engageSurv" element={<EngageSurv />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/publicProfile/:licenseNumber" element={<PublicProfile />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/verify/:licenseNo" element={<Verify />} />
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/resetmail" element={<ResetMail />} />
        <Route path="/profile/:licenseNumber" element={<Profile />} />
      </Route>

      {/* Dashboard Routes */}
      <Route element={<DashboardLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/maindashboard" element={<MainDashboard />} />
        <Route path="/finalDashL" element={<FinalDashboardL />} />
      </Route>

      {/* Not Found Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;